import { PureComponent } from "react";
import CoreAddonsComponent from "/components/addons/core-addons/core-addons-component";
import BaseHeaderComponent from "segments/desktop/header/layouts/base-header/base-header-component"; //new for monday 2.0
import LongFooterComponent from "segments/desktop/footer/layouts/long-footer/long-footer-component"; // //new for monday 2.0
import { MAIN_ID } from "constants/element-ids";

import BaseTemplate from "../base-template";
import SegmentsLayoutListComponent from "/components/segments/segments-layout-list/segments-layout-list-component";

export default class LongTemplateNew extends PureComponent {
  render() {
    let { headerUrl, exitPopup, stickyMode, pageConfig, isPreview } = this.props;

    const {
      segments,
      topbar,
      footer,
      socialButtons,
      topBanner,
      exitPopupConfig,
      aboveTheFoldSegmentsNumber
    } = pageConfig;
    const preventFooter = footer && footer.preventFooter;

    return (
      <BaseTemplate {...this.props} {...pageConfig}>
        <div>
          <BaseHeaderComponent
            {...topbar}
            url={headerUrl}
            headerBackgroundColor={"white"}
            stickyMode={stickyMode}
            allowSocialButtons={socialButtons && socialButtons.show}
            socialButtonsColor={socialButtons && socialButtons.color}
            socialButtonBlogStyle={socialButtons && socialButtons.blogStyle}
            topBanner={topBanner}
          />

          <main id={MAIN_ID}>
            <SegmentsLayoutListComponent
              isPreview={isPreview}
              segments={segments}
              numberOfAboveTheFoldSegments={aboveTheFoldSegmentsNumber}
            />
          </main>

          {!preventFooter && (
            <LongFooterComponent showTrustpilotReviews={pageConfig.showTrustpilotReviews} {...footer} />
          )}

          <CoreAddonsComponent exitPopup={exitPopup} exitPopupConfig={exitPopupConfig} />
        </div>
      </BaseTemplate>
    );
  }
}

LongTemplateNew.defaultProps = {
  headerUrl: "https://monday.com/",
  title: "monday.com",
  description: "",
  exitPopup: true,
  topbar: {}
};
